import 'src/shared/sidebar';
import 'src/shared/datepicker/date_field';
import 'src/shared/time_field/time_field';
import 'src/shared/number_input';
import 'src/shared/adaptive_select';
import 'src/shared/rich_ui_select/rich_ui_select';
import 'src/shared/tooltip_for_truncated_text';
import 'src/shared/knowledgebase_link/knowledgebase_link';
import 'src/shared/knowledgebase_link/styles.scss';
import 'src/shared/info_message/info_message';
import 'src/shared/info_message/styles.scss';
import 'src/schedule_showing_iframe_modal/schedule_showing_iframe_modal';
import 'src/schedule_showing_iframe_modal/styles.scss';
import 'src/shared/modal/modal';
import 'src/shared/modal/styles.scss';
import 'src/shared/toast/toast';
import 'src/shared/session_lifetime_warning/session_lifetime_warning';
import 'src/shared/session_lifetime_warning/styles.scss';
import 'src/shared/supplied_listing_link_warning/supplied_listing_link_warning';

import 'src/shared/signature_field/signature_field';
import 'src/shared/signature_field/styles.scss';
import 'src/shared/account/contract/contract';
import 'src/shared/sm-tabs/sm-tabs';
import 'src/shared/infinite_loader/infinite_loader';
import 'src/shared/colorpicker/colorpicker';

import 'src/shared/leftside_main_menu';
import 'src/shared/topbar_search';
import 'src/shared/universal_search';
import 'src/application/search/results_page';

import '../src/application/showings/timepickers/timepicker_builder';

// NOTE: PartialForm should be included before Toggle for properly events binding
import 'src/shared/partial_form';
import 'src/shared/toggle/toggle';

import 'src/shared/copy_icon';
import 'src/shared/mojo_select/mojo_select';

import 'src/shared/template_rich_editor/template_rich_editor';
import 'src/shared/template_rich_editor/template_bubble_editor';
import 'src/shared/template_rich_editor/themes/custom_bubble';

import 'src/components/navbar/sm-navbar';

//This is temporary fix for mobile apps. Ideally this css should be imported by two_way_messaging.js
import 'src/stylesheets/two_way_messaging.scss';

import LayoutUtils from 'src/utils/layout_utils';
window.LayoutUtils = LayoutUtils;
import Quill from 'quill';
window.Quill = Quill;
import FetchUtils from 'src/utils/fetch_utils';
window.FetchUtils = FetchUtils;

import DashboardUtils from 'src/utils/dashboard_utils';
window.DashboardUtils = DashboardUtils;
import RequiredListingUpdatesUtils from 'src/application/listings/required_listing_updates/utils';
window.RequiredListingUpdatesUtils = RequiredListingUpdatesUtils;

import ProspectUtils from 'src/utils/prospect_utils';
window.ProspectUtils = ProspectUtils;

//TODO:: remove when all js will be replaced to /javascripts folder
import Dropzone from 'dropzone';
window.Dropzone = Dropzone;
import SeeOnYoutOwn from 'src/prospects/see_on_your_own';
window.SeeOnYoutOwn = SeeOnYoutOwn;
import AlternateShowtimes from 'src/prospects/alternate_showtimes';
window.AlternateShowtimes = AlternateShowtimes;

import { appsignal } from '../src/utils/appsignal';
import { plugin as windowEventsPlugin } from '@appsignal/plugin-window-events';
import { plugin as breadcrumbsNetworkPlugin } from '@appsignal/plugin-breadcrumbs-network';
import { plugin as pathDecoratorPlugin } from '@appsignal/plugin-path-decorator';

appsignal.use(windowEventsPlugin({onerror: true, onunhandledrejection: false}));
appsignal.use(breadcrumbsNetworkPlugin());
appsignal.use(pathDecoratorPlugin());
import 'src/globals';

document.addEventListener('html-updated', () => {
  LayoutUtils.refreshIcons();
});
